<template>
  <div data-v-781d66cc="" class="root">
    <div class="main">
      <div class="left"></div>
      <div class="pclogin right" v-show="loginShow">
        <h3 class="login__title">盘锦市补充社会保险网上服务大厅</h3>

        <!--添加表单-->
        <el-form
          ref="loginFormRef"
          :model="loginForm"
          :rules="loginRules"
          class="login_form"
          label-width="0px"
        >
          <el-form-item prop="aab001" class="login_input">
            <el-input
              v-model="loginForm.aab001"
              prefix-icon="iconfont icondenglu" placeholder="请输入单位编号"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password" class="login_input">
            <el-input
              v-model="loginForm.password"
              prefix-icon="iconfont iconmima" placeholder="请输入密码"
              type="password"
            ></el-input>
          </el-form-item>
          <el-form-item class="btns">
            <el-button type="primary" @click="login" :loading="loginLoading" class="login_button"
              >登录</el-button
            >
            <!-- <el-button type="info" @click="resetLoginForm">重置</el-button> -->
          </el-form-item>
        </el-form>
        <el-button type="text" class="login__bin" @click="freeRegister"
          >注册</el-button
        >
        <el-button type="text" style="float: right" @click="forgetPassword" class="login__bin"
          >忘记密码</el-button
        >
      </div>
      <div class="register right" v-show="registerShow">
        <h3 class="login__title">注册</h3>
        <!--注册-->
        <el-form
          ref="registerFormRef"
          :model="registerForm"
          :rules="registerRules"
          class="login_form"
          label-width="0px"
        >
          <el-form-item
            prop="aab001"
            class="login_input"
            style="background-color: #f5f6f8"
          >
            <el-input
              v-model="registerForm.aab001"
              prefix-icon="iconfont icondenglu"
              placeholder="请输入20位单位编号"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password" v-show="password1" class="login_input">
            <el-input
              v-model="registerForm.password"
              prefix-icon="iconfont iconmima"
              placeholder="请输入密码"
              type="password"
            ><i slot="suffix" class="el-icon-view" @click="passwordShow" style="font-size: 20px;height: 50px;padding-top: 15px;"></i></el-input>
          </el-form-item>
          <el-form-item prop="password" v-show="password2" class="login_input">
            <el-input
              v-model="registerForm.password"
              prefix-icon="iconfont iconmima"
              placeholder="请输入用户密码"
            ><i slot="suffix" class="el-icon-key" @click="passwordShow" style="font-size: 20px;height: 50px;padding-top: 15px;"></i></el-input>
          </el-form-item>
          <el-form-item
            prop="lxrphone"
            class="login_input"
            style="background-color: #f5f6f8"
          >
            <el-input
              v-model="registerForm.lxrphone"
              prefix-icon="iconfont iconphone"
              placeholder="请输入手机号"

            ></el-input>
          </el-form-item>
          <el-form-item prop="snumber" class="login_input">
            <el-input
              placeholder="请输入统一社会信用代码"
              class="input-with-select"
              prefix-icon="iconfont iconqiye"
              v-model="registerForm.snumber"
            >
              <!-- <el-select
                prefix-icon="el-icon-school"
                v-model="select"
                slot="prepend"
                placeholder="企业"
              >
                <el-option label="企业" value="1"></el-option>
              </el-select> -->
            </el-input>
          </el-form-item>
          <el-form-item prop="aab002" class="login_input">
            <el-input
              v-model="registerForm.aab002"
              placeholder="请输入单位名称"
              prefix-icon="el-icon-collection"
            ></el-input>
          </el-form-item>
          <el-form-item  class="login_input">
            <el-checkbox v-model="readAndAccept" @change="readAndAccept1"
              >阅读并接受</el-checkbox
            >
            <el-button
              type="text"
              style="color: #3c6ef0"
              @click="dialogVisible = true"
              >《注册协议》</el-button
            >
          </el-form-item>

          <el-form-item class="btns">
            <el-button
              type="info"
              @click="login"
              class="login_button"
              v-show="loginbutton1"
              plain
              disabled
              >注册</el-button
            >
            <el-button
              type="primary"
              @click="registerUser"
              class="login_button"
              v-show="loginbutton2"
              >注册</el-button
            >
            <!-- <el-button type="info" @click="resetLoginForm">重置</el-button> -->
          </el-form-item>
        </el-form>
        <el-button
          type="text"
          style="float: right"
          class="login__bin"
          @click="goLogin"
          >去登录</el-button
        >
      </div>
      <div class="register right" v-show="forgetPasswordShow">
          <h3 class="login__title" style="text-align: left;">忘记密码</h3>
        <!--忘记密码-->
        <el-form
          ref="forgetPasswordFormRef"
          :model="forgetPasswordForm"
          :rules="forgetPasswordRules"
          class="login_form"
          label-width="0px"
        >
          <el-form-item
            prop="aab001"
            class="login_input"
            style="background-color: #f5f6f8"
          >
            <el-input
              v-model="forgetPasswordForm.aab001"
              prefix-icon="iconfont icondenglu"
              placeholder="请输入20位单位编号"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password" v-show="forgetPassword1" class="login_input">
            <el-input
              v-model="forgetPasswordForm.password"
              prefix-icon="iconfont iconmima"
              placeholder="请输入新密码"
              type="password"
            ><i slot="suffix" class="el-icon-view" @click="forgetPasswordShow1" style="font-size: 20px;height: 50px;padding-top: 15px;"></i></el-input>
          </el-form-item>
          <el-form-item prop="password" v-show="forgetPassword2" class="login_input">
            <el-input
              v-model="forgetPasswordForm.password"
              prefix-icon="iconfont iconmima"
              placeholder="请输入新密码"
            ><i slot="suffix" class="el-icon-key" @click="forgetPasswordShow1" style="font-size: 20px;height: 50px;padding-top: 15px;"></i></el-input>
          </el-form-item>
          <el-form-item prop="againpassword" v-show="forgetPassword3" class="login_input">
            <el-input
              v-model="forgetPasswordForm.againpassword"
              prefix-icon="iconfont iconmima"
              placeholder="请再次输入新密码"
              type="password"
            ><i slot="suffix" class="el-icon-view" @click="forgetPasswordShow2" style="font-size: 20px;height: 50px;padding-top: 15px;"></i></el-input>
          </el-form-item>
          <el-form-item prop="againpassword" v-show="forgetPassword4" class="login_input">
            <el-input
              v-model="forgetPasswordForm.againpassword"
              prefix-icon="iconfont iconmima"
              placeholder="请再次输入新密码"
            ><i slot="suffix" class="el-icon-key" @click="forgetPasswordShow2" style="font-size: 20px;height: 50px;padding-top: 15px;"></i></el-input>
          </el-form-item>

          <!-- <el-form-item prop="snumber" class="login_input">
            <el-input
              placeholder="请输入统一社会信用代码"
              class="input-with-select"
              prefix-icon="el-icon-medal-1"
              v-model="registerForm.snumber"
            >
              <el-select
                prefix-icon="el-icon-school"
                v-model="select"
                slot="prepend"
                placeholder="企业"
              >
                <el-option label="企业" value="1"></el-option>
              </el-select>
            </el-input>
          </el-form-item>
          <el-form-item prop="aab002" class="login_input">
            <el-input
              v-model="registerForm.aab002"
              placeholder="请输入机构名称"
              prefix-icon="el-icon-collection"
            ></el-input>
          </el-form-item> -->


          <el-form-item class="btns">
            <el-button
              type="primary"
              @click="updatPassword"
              class="login_button"

              >完成</el-button
            >
            <!-- <el-button type="info" @click="resetLoginForm">重置</el-button> -->
          </el-form-item>
        </el-form>
        <el-button type="text" class="login__bin" @click="freeRegister"
        >注册</el-button
      >
      <el-button
          type="text"
          style="float: right"
          class="login__bin"
          @click="goLogin"
          >去登录</el-button
      >
      </div>
    </div>

    <el-dialog

      :visible.sync="dialogVisible"
      width="500px"
    >
    <div style="height:550px;overflow-y:auto">
      <p
        class="MsoNormal"
        style="
          margin: 20px 0cm;
          font-size: 10.5pt;
          font-family: 等线;
          text-align: center;
          color: rgb(0, 0, 0);
        "
        align="center"
      >
        <b
          ><span style="font-size: 12pt; font-family: 微软雅黑, sans-serif"
            >《注册协议》<span
              lang="EN-US"
            ></span></span
        ></b>
      </p>
      <div style="text-indent:2em;font-family: 微软雅黑">
        感谢您申请盘锦市补充社会保险网上服务大厅账户！
      </div>
      <div style="text-indent:2em;font-family: 微软雅黑">
        在成为盘锦市补充社会保险网上服务大厅用户之前，请您仔细阅读以下条文，确保您理解并同意本协议全部内容。盘锦市补充社会保险网上服务大厅平台是由中国人民健康保险股份有限公司本溪中心支公司运营的补充社会保险的综合平台，域名为bx.lnbcgs.com。以下内容将构成您和中国人民健康保险股份有限公司本溪中心支公司之间的服务合同条款。
      </div>
      <div style="font-family: 微软雅黑;font-size: 20px;padding-top: 20px;color: rgb(0, 0, 0);">
        一、用户注册
      </div>
      <div style="text-indent:2em;font-family: 微软雅黑;padding-top: 15px;">
        您同意本协议并注册成功即成为盘锦市补充社会保险网上服务大厅的注册用户直至您的账户注销。盘锦市补充社会保险网上服务大厅可能在必要的时候对本协议条款及盘锦市补充社会保险网上服务大厅各单项服务协议进行更改，此种更改在盘锦市补充社会保险网上服务大厅上公布或在具体服务过程中经双方以口头、书面等形式协商一致生效。您可以选择停止使用盘锦市补充社会保险网上服务大厅相关的服务或者注销您在盘锦市补充社会保险网上服务大厅的账户，否则盘锦市补充社会保险网上服务大厅将认为您同意更改后的服务条款。未在盘锦市补充社会保险网上服务大厅发布或在具体服务过程中未经盘锦市补充社会保险网上服务大厅告知的服务条款将不具有法律效力，除非签有书面协议，并且仅对签署协议的当事人有效。
      </div>
      <div style="font-family: 微软雅黑;font-size: 20px;padding-top: 20px;color: rgb(0, 0, 0);">
        二、用户账户
      </div>
      <div style="text-indent:2em;font-family: 微软雅黑;padding-top: 15px;">
        您应当拥有中华人民共和国法律认可的完全民事权利能力和完全民事行为能力，否则您和能够代表您行使权利或承担责任的其他主体将承担一切后果。为此，您应当提供相应的证明。如果您是自然人，此类证明可以是您的居民身份证件、个人户营业执照。如果您是法人，此类证明可以是您的营业执照。如果您是其他组织类型，您应当提供相应的合法证明。
      </div>
      <div style="text-indent:2em;font-family: 微软雅黑;padding-top: 15px;">
        如果使用盘锦市补充社会保险网上服务大厅提供的各单项服务，您可能还需要提交其他相关的资料和信息。为了提供更好的服务，您也可以向我们提供其他资料和信息，我们将按照盘锦市补充社会保险网上服务大厅的隐私政策保护您的资料和信息。
      </div>
      <div style="text-indent:2em;font-family: 微软雅黑;padding-top: 15px;">
        您应当保护好您的账户，除非已经得到您的提前通知，盘锦市补充社会保险网上服务大厅将认为您的账户处于您的控制之下。如果您的账户在不受您控制的情况下处于风险状态或者已经发生损失，请您及时以有效方式通知盘锦市补充社会保险网上服务大厅，您可以要求盘锦市补充社会保险网上服务大厅暂停服务或者冻结账户。
      </div>
      <div style="text-indent:2em;font-family: 微软雅黑;padding-top: 15px;">
        如果您使用盘锦市补充社会保险网上服务大厅账户直接访问其他网站，您应当遵守该网站的服务条款。
      </div>
      <div style="font-family: 微软雅黑;font-size: 20px;padding-top: 20px;color: rgb(0, 0, 0);">
        三、账户管理
      </div>
      <div style="text-indent:2em;font-family: 微软雅黑;padding-top: 15px;">
        1、盘锦市补充社会保险网上服务大厅帐号的所有权归盘锦市补充社会保险网上服务大厅所有，用户完成申请注册手续后，获得盘锦市补充社会保险网上服务大厅帐号的使用权，该使用权仅属于初始申请注册人，禁止赠与、借用、租用、转让或售卖。盘锦市补充社会保险网上服务大厅因经营需要，有权回收用户的盘锦市补充社会保险网上服务大厅帐号。
      </div>
      <div style="text-indent:2em;font-family: 微软雅黑;padding-top: 15px;">
        2、用户可以更改、删除盘锦市补充社会保险网上服务大厅帐户上的个人资料、注册信息和单位信息及传送内容等，但需注意，删除有关信息的同时也会删除用户储存在系统中的文字和图片。用户需承担该风险。
      </div>
      <div style="text-indent:2em;font-family: 微软雅黑;padding-top: 15px;">
        3、用户有责任妥善保管注册帐号信息及帐号密码的安全，因用户保管不善可能导致遭受盗号或密码失窃，责任由用户自行承担。用户需要对注册帐号以及密码下的行为承担法律责任。用户同意在任何情况下不使用其他用户的帐号或密码。在用户怀疑他人使用其帐号或密码时，用户同意立即通知盘锦市补充社会保险网上服务大厅。
      </div>
      <div style="text-indent:2em;font-family: 微软雅黑;padding-top: 15px;">
        4、用户应遵守本协议的各项条款，正确、适当地使用本服务，如因用户违反本协议中的任何条款，盘锦市补充社会保险网上服务大厅在通知用户后有权依据协议中断或终止对违约用户盘锦市补充社会保险网上服务大厅帐号提供服务。同时，盘锦市补充社会保险网上服务大厅保留在任何时候收回盘锦市补充社会保险网上服务大厅帐号、用户名的权利。
      </div>
      <div style="text-indent:2em;font-family: 微软雅黑;padding-top: 15px;">
        5、如用户注册盘锦市补充社会保险网上服务大厅帐号后一年不登录，通知用户后，盘锦市补充社会保险网上服务大厅可以收回该帐号，以免造成资源浪费，由此造成的不利后果由用户自行承担。
      </div>
      <div style="font-family: 微软雅黑;font-size: 20px;padding-top: 20px;color: rgb(0, 0, 0);">
        四、用户责任
      </div>
      <div style="text-indent:2em;font-family: 微软雅黑;padding-top: 15px;">
        用户使用盘锦市补充社会保险网上服务大厅必须遵守所有适用的国家法律、地方法规和国际准则。用户对用户账户进行的一切操作及言论负完全的责任，用户注销账户后，仍然应当对注销前的操作和言论负责。

      </div>
      <div style="text-indent:2em;font-family: 微软雅黑;padding-top: 15px;">
        用户必须遵循：
      </div>
      <div style="text-indent:2em;font-family: 微软雅黑;padding-top: 15px;">
        （1）从中国境内向外传输技术性资料时必须符合中国有关法规。
      </div>
      <div style="text-indent:2em;font-family: 微软雅黑;padding-top: 15px;">
        （2）使用网络服务不作非法用途
      </div>
      <div style="text-indent:2em;font-family: 微软雅黑;padding-top: 15px;">
        （3）不干扰或混乱网络服务
      </div>
      <div style="text-indent:2em;font-family: 微软雅黑;padding-top: 15px;">
        （4）遵守所有使用网络服务的网络协议、规定、程序和惯例。
      </div>
      <div style="text-indent:2em;font-family: 微软雅黑;padding-top: 15px;">
        用户须承诺不传输任何非法的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的，淫秽等信息资料。用户也不能传输任何教唆他人构成犯罪行为的资料。不得进行任何有可能对盘锦市补充社会保险网上服务大厅的系统造成任何不良的影响的操作，不能传输助长国内不利条件和涉及国家安全的资料。不能传输任何不符合当地法规、国家法律和国际准则的资料。未经许可而非法进入其它电脑系统是禁止的。若用户的行为不符合以上提到的服务条款，盘锦市补充社会保险网上服务大厅单方面有权冻结或注销用户账户。用户需对用户本身在网上的行为承担法律责任。用户若在盘锦市补充社会保险网上服务大厅上散布和传播反动、色情或其他违反国家法律的信息，盘锦市补充社会保险网上服务大厅的系统记录有可能作为用户违反法律的证据。
      </div>
      <div style="font-family: 微软雅黑;font-size: 20px;padding-top: 20px;color: rgb(0, 0, 0);">
        五、数据储存
      </div>
      <div style="text-indent:2em;font-family: 微软雅黑;padding-top: 15px;">
        1、盘锦市补充社会保险网上服务大厅不对用户在本服务中相关数据的删除或储存失败负责。
      </div>
      <div style="text-indent:2em;font-family: 微软雅黑;padding-top: 15px;">
        2、盘锦市补充社会保险网上服务大厅可以根据实际情况自行决定用户在本服务中数据的最长储存期限，并在服务器上为其分配数据最大存储空间等。用户可根据自己的需要自行备份本服务中的相关数据。
      </div>
      <div style="text-indent:2em;font-family: 微软雅黑;padding-top: 15px;">
        3、如用户停止使用本服务或本服务终止，盘锦市补充社会保险网上服务大厅可以从服务器上永久地删除用户的数据。本服务停止、终止后盘锦市补充社会保险网上服务大厅没有义务向用户返还任何数据。
      </div>
      <div style="font-family: 微软雅黑;font-size: 20px;padding-top: 20px;color: rgb(0, 0, 0);">
        六、风险承担
      </div>
      <div style="text-indent:2em;font-family: 微软雅黑;padding-top: 15px;">
        1、用户理解并同意，盘锦市补充社会保险网上服务大厅仅为用户提供信息分享、传送及获取的平台，用户必须为自己注册帐号下的一切行为负责，包括用户所传送的任何内容以及由此产生的任何后果。用户应对盘锦市补充社会保险网上服务大厅及本服务中的内容自行加以判断，并承担因使用内容而引起的所有风险，包括因对内容的正确性、完整性或实用性的依赖而产生的风险盘锦市补充社会保险网上服务大厅无法且不会对因用户行为而导致的任何损失或损害承担责任。
      </div>
      <div style="text-indent:2em;font-family: 微软雅黑;padding-top: 15px;">
        如果用户发现任何人违反本协议约定或以其他不当的方式使用本服务，请立即向盘锦市补充社会保险网上服务大厅举报或投诉，盘锦市补充社会保险网上服务大厅将依本协议约定进行处理。
      </div>
      <div style="text-indent:2em;font-family: 微软雅黑;padding-top: 15px;">
        2、用户理解并同意，因业务发展需要，盘锦市补充社会保险网上服务大厅保留单方面对本服务的全部或部分服务内容变更、暂停、终止或撤销的权利，用户需承担此风险。
      </div>
      <div style="font-family: 微软雅黑;font-size: 20px;padding-top: 20px;color: rgb(0, 0, 0);">
        七、盘锦市补充社会保险网上服务大厅服务
      </div>
      <div style="text-indent:2em;font-family: 微软雅黑;padding-top: 15px;">
        盘锦市补充社会保险网上服务大厅为用户提供补充工伤保险、补充医疗保险等相关服务各项服务。用户应当按照盘锦市补充社会保险网上服务大厅的服务规则和页面提示进行操作，也可以直接联系盘锦市补充社会保险网上服务大厅获取更多的服务。盘锦市补充社会保险网上服务大厅各单项服务协议与本协议冲突或是有特别规定的，应当优先适用各单项服务协议。
      </div>
      <div style="text-indent:2em;font-family: 微软雅黑;padding-top: 15px;">
        盘锦市补充社会保险网上服务大厅的各项服务费用在盘锦市补充社会保险网上服务大厅上公布，盘锦市补充社会保险网上服务大厅有权根据有关政策的变化、市场情况、服务范围变化等原因，单方面调整价格标准，调整的项目将在盘锦市补充社会保险网上服务大厅上更新，不作额外的通知。盘锦市补充社会保险网上服务大厅有权拒绝为不按照盘锦市补充社会保险网上服务大厅要求提供信息或不服从盘锦市补充社会保险网上服务大厅服务规则的用户提供服务，有权注销或者冻结该用户账户。
      </div>
      <div style="text-indent:2em;font-family: 微软雅黑;padding-top: 15px;">
        盘锦市补充社会保险网上服务大厅的数据来源于互联网，版权归源网站所有，平台通过技术手段对信息进行汇总实现快照，无法避免后续网站内容的变更，汇总的数据如有出入本站不承担责任。
      </div>
      <div style="font-family: 微软雅黑;font-size: 20px;padding-top: 20px;color: rgb(0, 0, 0);">
        八、盘锦市补充社会保险网上服务大厅免责条款
      </div>
      <div style="text-indent:2em;font-family: 微软雅黑;padding-top: 15px;">
        因下列情形无法按照约定提供各项服务时，盘锦市补充社会保险网上服务大厅不承担责任，包括但不限于：
      </div>
      <div style="text-indent:2em;font-family: 微软雅黑;padding-top: 15px;">
        （1）盘锦市补充社会保险网上服务大厅公告的休假或者系统维护的。
      </div>
      <div style="text-indent:2em;font-family: 微软雅黑;padding-top: 15px;">
        （2）电信设备出现故障不能进行数据传输的。
      </div>
      <div style="text-indent:2em;font-family: 微软雅黑;padding-top: 15px;">
        （3）因台风、地震、海啸、洪水、停电、战争、恐怖袭击等不可抗力之因素，造成盘锦市补充社会保险网上服务大厅障碍不能提供服务的。
      </div>
      <div style="text-indent:2em;font-family: 微软雅黑;padding-top: 15px;">
        （4）由于黑客攻击、电信部门技术调整或故障、网站升级、银行方面的问题等原因而造成的服务中断或者延迟的。
      </div>
      <div style="font-family: 微软雅黑;font-size: 20px;padding-top: 20px;color: rgb(0, 0, 0);">
        九、知识产权保护
      </div>
      <div style="text-indent:2em;font-family: 微软雅黑;padding-top: 15px;">
        用户不得擅自在全球任何国家和地区申请与盘锦市补充社会保险网上服务大厅及其他服务的名称、标识、品牌、特色标志、域名相同或类似的商标、服务商标、域名、著作权等。用户不得擅自使用、复制、修改、改编、翻译、汇编、转载、发行盘锦市补充社会保险网上服务大厅所有内容，包括但不限于文字作品、图片作品、摄影作品、示意图、网站架构、网站画面的安排、网页设计。
      </div>
      <div style="font-family: 微软雅黑;font-size: 20px;padding-top: 20px;color: rgb(0, 0, 0);">
        十、隐私政策
      </div>
      <div style="text-indent:2em;font-family: 微软雅黑;padding-top: 15px;">
        盘锦市补充社会保险网上服务大厅隐私政策构成本协议的有效内容。隐私政策调整的，适用最新的隐私政策。
      </div>
      <div style="font-family: 微软雅黑;font-size: 20px;padding-top: 20px;color: rgb(0, 0, 0);">
        十一、法律适用和管辖
      </div>
      <div style="text-indent:2em;font-family: 微软雅黑;padding-top: 15px;">
        本协议及其他单项服务协议适用中华人民共和国法律，法律没有明文规定的，按照盘锦市补充社会保险网上服务大厅的服务惯例解释。协议的部分条款发生无效的情形，不受影响的其他条款和协议仍然有效。因本协议及其他单项服务协议产生的争议，辽宁省本溪市人民法院为有权管辖法院。
      </div>
      <div style="font-family: 微软雅黑;font-size: 20px;padding-top: 20px;color: rgb(0, 0, 0);">
        十二、其他
      </div>
      <div style="text-indent:2em;font-family: 微软雅黑;padding-top: 15px;">
        工作日是指盘锦市补充社会保险网上服务大厅的营业日。除非盘锦市补充社会保险网上服务大厅公告通知休假，一般为中华人民共和国适用的休息日以及法定节假日之外的正常工作日。日期的计算使用公历年月日，时间的计算使用北京时间。
      </div>
      <div style="text-indent:2em;font-family: 微软雅黑;padding-top: 15px;">
        盘锦市补充社会保险网上服务大厅通过公告通知，公告的时间为送达到用户的时间；通过盘锦市补充社会保险网上服务大厅网页向用户提醒，提醒出现的时间为送达的时间；通过用户提供的联系方式向用户送达，用户或其代表签收、用户系统接收的时间为送达的时间。
      </div>


    </div>
      <span></span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="agreement(0)">取 消</el-button>
        <el-button type="primary" @click="agreement(1)">我已同意</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
    export default {
        data() {
            //手机号验证
            var checkPhone = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('手机号不能为空'));
                } else {
                    const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
                    if (reg.test(value)) {
                        callback();
                    } else {
                        return callback(new Error('请输入正确的手机号'));
                    }
                }
            };
            return {
                loginForm: {
                    aab001: "",
                    password: "",
                },
                registerForm: {
                    snumber: "",
                    password: "",
                    lxrphone: "",
                    aab002: "",
                    aab001: "",
                    zznum: "0",
                    txnum: "0",

                },
                forgetPasswordForm: {
                    aab001: "",
                    password: "",
                    againpassword: "",

                },
                //注册展示
                registerShow: false,
                //登录展示
                loginShow: true,
                //下拉菜单   企业
                select: "",
                //注册协议
                dialogVisible: false,
                //阅读并接受
                readAndAccept: false,
                //忘记密码div
                forgetPasswordShow: false,
                //注册
                loginbutton1: true,
                loginbutton2: false,
                //密码
                password1: true,
                password2: false,

                //登录等待
                loginLoading: false,

                //忘记密码

                forgetPassword1: true,
                forgetPassword2: false,
                forgetPassword3: true,
                forgetPassword4: false,

                loginRules: {
                    aab001: [{
                        required: true,
                        message: "请输入单位编号",
                        trigger: "blur",
                    }, {
                        min: 20,
                        max: 20,
                        message: "单位编码错误！",
                        trigger: "blur",
                    }, ],
                    password: [{
                        required: true,
                        message: "请输入密码",
                        trigger: "blur",
                    }, {
                        min: 6,
                        max: 8,
                        message: "密码为 6~8 位",
                        trigger: "blur",
                    }, ],
                },
                registerRules: {

                    aab001: [{
                        required: true,
                        message: "请输入单位编码",
                        trigger: "blur",
                    }, {
                        min: 20,
                        max: 20,
                        message: "长度 20 个字符！",
                        trigger: "blur",
                    }, ],
                    password: [{
                        required: true,
                        message: "请输入密码",
                        trigger: "blur",
                    }, {
                        min: 6,
                        max: 8,
                        message: "密码为 6~8 位",
                        trigger: "blur",
                    }, ],
                    lxrphone: [{
                       message: '请输入手机号',
                        required: true,
                        trigger: 'blur'
                    }],
                    snumber: [{
                        required: true,
                        message: "请输入统一社会信用代码",
                        trigger: "blur",
                    }, {
                        min: 6,
                        max: 50,
                        message: "统一社会信用代码错误！",
                        trigger: "blur",
                    }, ],
                    aab002: [{
                        required: true,
                        message: "请输入机构名称",
                        trigger: "blur",
                    }, {
                        min: 1,
                        max: 100,
                        message: "机构名称输入错误！",
                        trigger: "blur",
                    }, ],

                },
                forgetPasswordRules: {
                    aab001: [{
                        required: true,
                        message: "请输入单位编号",
                        trigger: "blur",
                    }, {
                        min: 20,
                        max: 20,
                        message: "长度 20 个字符！",
                        trigger: "blur",
                    }, ],
                    password: [{
                        required: true,
                        message: "请输入密码",
                        trigger: "blur",
                    }, {
                        min: 6,
                        max: 8,
                        message: "密码为 6~8 位",
                        trigger: "blur",
                    }, ],
                    againpassword: [{
                        required: true,
                        message: "请再次输入密码",
                        trigger: "blur",
                    }, {
                        min: 6,
                        max: 8,
                        message: "密码为 6~8 位",
                        trigger: "blur",
                    }, ],

                },
            };
        },
        methods: {
            resetLoginForm() {
                this.$refs.loginFormRef.resetFields();
            },
            //注册
            freeRegister() {
                this.registerShow = true;
                this.loginShow = false;
                this.forgetPasswordShow = false;
            },
            //忘记密码
            forgetPassword() {

                this.loginShow = !this.loginShow;
                this.forgetPasswordShow = !this.forgetPasswordShow;
            },

            //去登陆
            goLogin() {
                this.registerShow = false;
                this.loginShow = true;
                this.forgetPasswordShow = false;

            },
            //阅读并接受
            readAndAccept1() {
                this.loginbutton1 = !this.loginbutton1;
                this.loginbutton2 = !this.loginbutton2;
            },
            //查看协议书
            agreement(a) {
                if (a == 1) {
                    this.readAndAccept = !this.readAndAccept;
                    this.loginbutton1 = !this.loginbutton1;
                    this.loginbutton2 = !this.loginbutton2;
                    this.dialogVisible = !this.dialogVisible;
                } else {
                    this.dialogVisible = !this.dialogVisible;
                    this.readAndAccept = false;
                    this.loginbutton1 = true;
                    this.loginbutton2 = false;
                }
            },
            //显示隐藏密码
            passwordShow() {
                this.password1 = !this.password1;
                this.password2 = !this.password2;
            },

            //忘记密码时显示隐藏密码
            forgetPasswordShow1() {
                this.forgetPassword1 = !this.forgetPassword1;
                this.forgetPassword2 = !this.forgetPassword2;

            },
            //忘记密码时显示隐藏密码
            forgetPasswordShow2() {

                this.forgetPassword3 = !this.forgetPassword3;
                this.forgetPassword4 = !this.forgetPassword4;
            },
            login() {
                this.loginLoading = true;
                this.$refs.loginFormRef.validate(async(valid) => {
                    if (!valid) {
                        this.loginLoading = false;
                        return;
                    }
                    // 调用get请求
                    const {
                        dataType: json,
                        data: res
                    } = await this.$http.post(
                        "login",
                        this.loginForm
                    ).catch((err) => {

                        this.$message.error("登录失败！！！")
                        this.loginLoading = false;
                    });
                    if (res.flag == "ok") {
                        window.sessionStorage.setItem("flag", "ok"); // session 放置
                        // window.sessionStorage.setItem("user", JSON.stringify(res.user)); // session 放置
                        this.resetSetItem('user', JSON.stringify(res.user));
                        this.$message({
                            duration: 600,
                            type: 'success',
                            message: '登录成功！！！'
                        });
                        this.loginLoading = false;
                        this.$router.push({
                            path: "/home",
                        });
                    } else {
                        this.$message.error(res.flag);
                        this.loginLoading = false;
                    }
                });
            },
            // 添加用户
            registerUser() {
                this.$refs.registerFormRef.validate(async valid => {
                    if (!valid) return;
                    // 发起请求
                    const {
                        data: res
                    } = await this.$http.post("registerUser", this.registerForm).catch((err) => {

                        this.$message.error("注册失败！！！")
                        this.fullscreenLoading = false;
                    });
                    if (res != "success") {
                        // this.userinfo.state = !userinfo.state;
                        return this.$message.error(res);
                    }
                    this.$message.success("注册成功！！！");
                    this.goLogin();
                    //隐藏
                    // this.addDialogVisible = false;
                    // this.getUserList();
                })
            },
            //更改密码
            updatPassword() {
                this.$refs.forgetPasswordFormRef.validate(async valid => {
                    if (!valid) return;
                    if (this.forgetPasswordForm.password != this.forgetPasswordForm.againpassword) {
                        return this.$message.error("密码不一致，请更改输入密码！！！");
                    }
                    // 发起请求
                    const {
                        data: res
                    } = await this.$http.post("updatePassword", this.forgetPasswordForm);
                    if (res != "success") {
                        // userinfo.state = !userinfo.state;
                        return this.$message.error("找回密码失败！！！");
                    }

                    this.$message.success("找回密码成功！！！");
                    this.$refs.forgetPasswordFormRef.resetFields(); // 重置表单项
                    // this.$router.go(0);
                    //隐藏
                    // this.addDialogVisible = false;
                    // this.getUserList();
                })
            },


        },
    };
</script>

<style lang="less" scoped>
    .root {
        width: 100vw;
        height: 100vh;
        overflow: hidden;
        background-color: #f7f8fb;
        background-image: url(../assets/root.4adc41ac.png);
        background-size: cover;
        position: relative;
    }

    .main {
        font-size: 0;
        max-width: 1200px;
        min-width: 1000px;
        width: 80%;
        height: 80%;
        max-height: 712px;
        min-height: 640px;
        background: #fff;
        border-radius: 13px;
        -webkit-box-shadow: 0 17px 41px 0 rgba(95, 95, 95, 0.17);
        box-shadow: 0 17px 41px 0 rgba(95, 95, 95, 0.17);
        margin: auto;
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        z-index: 1;
    }

    .left {
        width: 50%;
        height: 100%;
        background-image: url(../assets/bg.bf2b2105.jpg);
        background-size: cover;
        border-top-left-radius: 13px;
        border-bottom-left-radius: 13px;
    }

    .right {
        font-size: 14px;
        width: 50%;
    }

    .pclogin {
        max-width: 460px;
        margin: 0 auto;
    }

    .login__title {
        margin: 0 auto;
        margin-bottom: 0px;
        margin-bottom: 32px;
        text-align: center;
        line-height: 22px;
        font-family: PingFangSC-Medium;
        font-size: 24px;
        color: #3b3b3b;
    }

    .btns {
        display: flex; // 弹性布局
        justify-content: center; // 尾部对齐
    }

    .login_form {
        width: 100%;
        margin: auto;
    }

    .login_button {
        width: 460px;
        height: 50px;
    }
    /* .login_input {
        height: 50px;
        line-height: 50px;
    } */

    /deep/.el-input__inner {
        height: 50px;
        line-height: 50px;
        background-color: #f5f6f8;
    }

    /deep/.el-button--text {
        line-height: 1;
        font-family: PingFangSC-Regular;
        font-size: 16px;
        padding-bottom: 0;
        color: #969696;
        border: none;
        padding-top: 16px;
    }

    .register {
        max-width: 460px;
        margin: 0 auto;
    }

    /deep/.el-select .el-input {
        width: 130px;
    }

    /deep/.input-with-select .el-input-group__prepend {
        background-color: #f5f6f8;
    }
</style>
